import { Component, Input } from '@angular/core';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';

@Component({
  selector: 'app-tipologie-tipovisita',
  templateUrl: './tipologie-tipovisita.component.html',
  styleUrls: ['./tipologie-tipovisita.component.css']
})
export class TipologieTipovisitaComponent {

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  @Input() tipologie: any;
  @Input() cancellazione: boolean;


  constructor(
    private appoggioService: AppoggioService
  ) {
  }
}
